module.exports = __webpack_public_path__ + "img/act-招聘管理.b38d4fee.png";